import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging";
import { onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { store } from "../utils/store";
import { addNotificationToken } from "../utils/PushNotification/pushNotificationService";
import { useEffect } from "react";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyBK-gITHyQRUAvdaLvGkkvrM7Z3MKig-PE",
  authDomain: "pulse-b45a0.firebaseapp.com",
  projectId: "pulse-b45a0",
  storageBucket: "pulse-b45a0.firebasestorage.app",
  messagingSenderId: "921456583167",
  appId: "1:921456583167:web:2f11e3d699c177b072c7ca",
  measurementId: "G-MBBKXQ65DZ"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const signInWithPhone  = signInWithPhoneNumber 
export const Recaptcha = RecaptchaVerifier
export const generateToken = async () => {
  if(store.getState().auth.userId){
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BH31ZiyuxzPG6DbL9H6idkj9h8h8I974z--vZiC5VyYoFYOVApNVR8rYtEN8T4FPf6Fw5Q4MJH0bQ6RIJR7WkvI",
      });
      console.log(token,"tokentokentokentoken")
      const payload = {
        userId: store.getState().auth.userId,
        token: token,
        source:"web"
      }
      
      const notificationKey = `notificationTokenSaved_${payload.userId}`;
      
      // if (!localStorage.getItem(notificationKey)) {
        // console.log(payload, "payloadddddddddddddd");
        const response = await addNotificationToken(payload);
      
        // if (response?.success === 1) {
        //   localStorage.setItem(notificationKey, "true");
        // }
      // }
      
      return token;
    } else {
      console.warn("Notification permission denied");
      return null;
    }

  }
  };
  
  
